<script setup lang="ts">
    import Login from "@/components/auth/forms/Login.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { router, Link } from "@inertiajs/vue3";
    import { onMounted, onUnmounted, toRefs, inject } from "vue";
    import { storeToRefs } from "pinia";
    import CloseIcon from "@icons/closeIcon.svg";
    import { useSettingsStore } from "@/store/settings";
    // import { route } from "ziggy-js";

    const openLoginFlyout = defineModel("visible",{
        type: Boolean,
        default: false
    });

    let route = inject("route");

    const settingsStore = useSettingsStore();
    const { flyoutMessage } = storeToRefs(settingsStore);
    const closeLoginFlyout = () => {
        openLoginFlyout.value = false;
    };

    onMounted(()=>{
        let removeEventListener = router.on("navigate", () => {
            if (openLoginFlyout.value) {
                closeLoginFlyout();
            }
        });

        //before the window closes, remove the event listener
        window.addEventListener("beforeunload", () => {
            removeEventListener();
        });
    })

  
</script>

<template>
    <PrimeDrawer
        v-model:visible="openLoginFlyout"
        position="right"
        :dismissable="true"
    >
    <div class="authorization_popup">
        <div class="authorization_popup-close_container">
            <CloseIcon class="close" @click="closeLoginFlyout()" alt="close_icon"/>
        </div>
        <div class="authorization_popup-title headline-m" >Login</div>

        <div style="margin: 1.25rem 0;" v-if="flyoutMessage && flyoutMessage.type == 'info'" class="notification notification-informational">
            <p class="paragraph-details"><strong v-if="flyoutMessage.headline">{{ flyoutMessage.headline }}</strong>{{ flyoutMessage.message }}</p>
        </div>
        <div style="margin: 1.25rem 0;" v-if="flyoutMessage && flyoutMessage.type == 'error'" class="notification notification-error">
            <p class="paragraph-details"><strong v-if="flyoutMessage.headline">{{ flyoutMessage.headline }}</strong>{{ flyoutMessage.message }}</p>
        </div>
        <Login
            :is-flyout="true"
            @set-as-logged-in="closeLoginFlyout()"
        />
        <p class="paragraph-details"><span class="authorization_popup-new_customer">New Customer?</span> <Link :href="route('web.register')" class="authorization_popup-forgot">Create an Account</Link>
        </p>
        <div class="authorization_popup-dealer_block">
            <h2 class="headline-xs authorization-banner_title">Become a Rothco Dealer</h2>
            <p class="paragraph-caption authorization_popup-text">Sign up to receive exclusive pricing and premier service for your
                business.</p>
            <RothcoCta :href="route('index.becomeADealer')" class="secondary small">Learn More & Apply</RothcoCta>
            <p class="paragraph-caption authorization_popup-dealer_link-dealer">Already a Dealer? <Link :href="route('index.dealerApplication', {existing: 1})"
                    class="authorization_popup-dealer_link paragraph-details">Set Up An Online Account</Link></p>
        </div>
    </div>
    </PrimeDrawer>
</template>

<style scoped></style>
